import * as actionTypes from "./appActionTypes";

const initialState = {
  loading: false,
  error: null,
  menuLoading: false,
  states: [],
  suppliers: [],
  countries: [],
  dynamicRoutes: [],
  keys: [],
  category: [],
  make: [],
  models: [],
  holds: [],
  recallStages: {}
};

const configRequestStart = (state) => ({ ...state, error: null, loading: true });

const configRequestSuccess = (state, action) => ({
  ...state,
  fuelType: action.data.fuelType || [],
  states: action.data.states || [],
  countries: action.data.countries || [],
  suppliers: action.data.suppliers || [],
  dynamicRoutes: action.data.headers || [],
  keys: action.data.keys || [],
  error: null,
  category: Array.isArray(action.data.vasCategoryList) && action.data.vasCategoryList.map((i) => i?.value), // Object.values(action.data.vasCategoryList || {}).length ? Object.values(action.data.vasCategoryList) : [],
  make: action.data.makeList,
  loading: false,
  vehicleSummarytab: action.data.vehicleSummarytab || [],
  holds: action.data.holds || [],
  feedConfig: action.data.feedConfig || {},
  bulkUploadFileConfig: action.data.bulkUploadFileConfig || {},
  recallStages: action.data.recallStages || {},
  accessConfig: action.data.accessConfig || {},
  regoDocConfig: action.data.regoDocConfig || [],
  vehicleStatusConfig: action.data.vehicleStatusConfig || {},
  invoiceFeeTypes: action.data.invoiceFeeTypes || []
});

const configRequestFail = (state, action) => ({ ...state, error: action.error, loading: false });
const fetchModelStart = (state) => ({ ...state, error: null, loading: true });

const fetchModelSuccess = (state, action) => ({
  ...state,
  loading: false,
  error: null,
  models: action.data
});
const fetchModelFail = (state, action) => ({ ...state, error: action.data, loading: false });

const fetchMenusStart = (state) => ({
  ...state,
  menuLoading: true
});
const fetchMenuSuccess = (state, action) => ({
  ...state,
  menus: action.data,
  menuLoading: false
});
const fetchMenuFail = (state) => ({
  ...state,
  menuLoading: false
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONFIG_REQUEST_START:
      return configRequestStart(state, action);
    case actionTypes.CONFIG_REQUEST_SUCCESS:
      return configRequestSuccess(state, action);
    case actionTypes.CONFIG_REQUEST_FAIL:
      return configRequestFail(state, action);
    case actionTypes.FETCH_MODEL_START:
      return fetchModelStart(state, action);
    case actionTypes.FETCH_MODEL_SUCCESS:
      return fetchModelSuccess(state, action);
    case actionTypes.FETCH_MODEL_FAIL:
      return fetchModelFail(state, action);
    case actionTypes.FETCH_MENU_START:
      return fetchMenusStart(state, action);
    case actionTypes.FETCH_MENU_SUCCESS:
      return fetchMenuSuccess(state, action);
    case actionTypes.FETCH_MENU_FAIL:
      return fetchMenuFail(state, action);
    default:
      return state;
  }
};

export default reducer;
